import gql from 'graphql-tag';

export const GET_APP_USERS = gql`
  query AppUsers {
    appUserAPI {
      name
    }
  }
`;
